/** Sub-navigation shared by the Event Reporting pages (the sidebar has one "Events" entry). */
import { Link, useLocation } from "react-router-dom";

const TABS = [
  { to: "/events", label: "Event Recaps" },
  { to: "/events/appointments", label: "Appointment Updates" },
  { to: "/events/config", label: "Rates" },
];

/** Recaps own /events and everything under it except the other two tabs. */
function activeTab(path: string): string {
  if (path.startsWith("/events/appointments")) return "/events/appointments";
  if (path.startsWith("/events/config")) return "/events/config";
  return "/events";
}

export function EventsNav() {
  const active = activeTab(useLocation().pathname);
  return (
    <nav className="flex gap-1 mb-5 border-b hairline" aria-label="Event Reporting">
      {TABS.map((t) => {
        const on = t.to === active;
        return (
          <Link
            key={t.to}
            to={t.to}
            aria-current={on ? "page" : undefined}
            className="px-3 py-2 -mb-px text-[13.5px] font-serif border-b-2 t-base"
            style={{ color: on ? "var(--ink)" : "var(--ink-3)", borderColor: on ? "var(--ink)" : "transparent" }}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
